import {Button, Loader, ModalRequest} from "../common";
import {useQuery} from "react-query";
import {useAlert} from "../common/Alert";
import {ALERT_TYPES} from "../../types";

const GenerationLinkModal = (
  { open, onClose, isProduct = false, productID = '' }:
  { open: boolean; onClose: () => void; isProduct?: boolean; productID?: string | number }
) => {
  const { setAlert } = useAlert();

  const { data, isLoading }: { data: any | undefined; isLoading: boolean } = useQuery(["productsFormFields", productID], {
    refetchOnWindowFocus: false,
    enabled: isProduct && !!productID
  })

  const handleCopyText = () => {
    navigator.clipboard.writeText(data?.extra_data?.cpa?.link);
    setAlert('Ссылка скопирована в буфер обмена!', ALERT_TYPES.SUCCESS);
  }

  return (
    <ModalRequest open={open} onClose={onClose} title="" className="max-w-[80%] sm:max-w-full">
      <>
        {isLoading
          ? <Loader />
          : <>
            <p className="pt-4 font-bold text-center text-black mb-4">Ваша реферальная ссылка</p>
            <p className="py-2 px-4 border rounded text-center border-black text-black">{data?.extra_data?.cpa?.link}</p>
            <Button title="Скопировать ссылку" className="w-full mt-5" onClick={handleCopyText} />
          </>
        }
      </>
    </ModalRequest>
  )
}

export default GenerationLinkModal;
